import { Component } from "@angular/core";
import { doc, Firestore, getDoc } from "@angular/fire/firestore";
import { ActivatedRoute, Data, Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { LoadingService } from "@core/loading.service";
import { from, of, throwError } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

@Component({
  selector: "app-prosub-page",
  templateUrl: "./prosub-page.component.html",
  styleUrls: ["./prosub-page.component.css"],
  standalone: true,
})
export class ProsubPageComponent {
  prosub_id: string;
  prosubIdDetails: Data;
  userId: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private loadingService: LoadingService,
    private authService: AuthService,
    private firestore: Firestore
  ) {
    this.loadingService.present();

  }

  async ngOnInit() {
    await this.authService.getUid("ProsubPageComponent").then((uid) => {
      this.userId = uid;
    })

    this.route.queryParamMap?.subscribe((params: Data) => {
      if (params?.params?.prosub_id && this.userId) {
        this.prosub_id = params.params.prosub_id;
        const prosubDocRef = doc(this.firestore, `/general_modules/prosub_id/${this.prosub_id}/details`);

        from(getDoc(prosubDocRef)).pipe(
          map(snapshot => snapshot.data()),
          switchMap(prosubIdDetails => {
            if (!prosubIdDetails) {
              return throwError(() => new Error("Invalid prosub id"));
            }
            this.prosubIdDetails = prosubIdDetails;

            const restrictedOfferDocRef = doc(
              this.firestore,
              `/users/${this.userId}/restricted_offers/${prosubIdDetails.offer_id}`
            );

            return from(getDoc(restrictedOfferDocRef)).pipe(
              map(restrictedOfferSnap => restrictedOfferSnap.data())
            );
          }),
          catchError(err => {
            this.handleError();
            return of(null); // or throwError(err) if you want to propagate error downstream
          })
        ).subscribe(result => {
          this.loadingService.dismiss();
          if (this.prosubIdDetails?.optional_page && !result) {
            this.router.navigate([this.prosubIdDetails.optional_page], {
              queryParams: params.params,
            });
          } else {
            this.router.navigateByUrl('/home');
          }
        });

      } else {
        this.handleError();
      }
    });
  }

  private handleError() {
    this.loadingService.dismiss();
    this.authService
      .getConstantsMsg("1115")
      .then((translatedMsg) => {
        const defaultMsg = {
          message: {
            line_1: "Invalid prosub id",
            line_2: "",
          },
          style: {
            icon: "tick circle info.svg",
            type: "Info",
          },
        };
        this.authService?.showToastMessage(translatedMsg, defaultMsg);
        this.router.navigateByUrl("/home");
      })
      .catch((error) => {
        this.router.navigateByUrl("/home");
        return error;
      });
  }
}
